module.exports = __webpack_public_path__ + "static/img/曾任伟.4e77fd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/combat/师资介绍/实战导师/曾任伟.png
// module id = Aa4k
// module chunks = 0